/**
 * Shared constants for platform_fe_public and platform_fe_auth.
 * Use these instead of magic strings for API paths, route prefixes, and app identifiers.
 */

/** API path prefixes (relative to API_BASE_URL). */
export const API_PATHS = {
  /** Customer/portal API prefix (v1 module paths). */
  API_V1: 'v1',
  /** Admin API prefix. */
  ADMIN: 'admin',
  /** Health check. */
  HEALTH: 'health',
};

/** Common route path segments (for building paths or matching). */
export const ROUTE_SEGMENTS = {
  HOME: '/',
  ABOUT: '/about',
  LOGIN: '/login',
  LOGOUT: '/logout',
  LEGAL: '/legal',
  PRESS_KIT: '/press-kit',
};

/** Known environment names. */
export const ENV_NAMES = {
  DEV: 'dev',
  INT: 'int',
  UAT: 'uat',
  PROD: 'prod',
  STAGING: 'staging',
  DEVELOPMENT: 'development',
};

/** Default API base URL when not set via env. */
export const DEFAULT_API_BASE_URL = 'http://localhost:7071';
